import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import KakaoChannel from "./KakaoChannel"; // KakaoChannel 컴포넌트 임포트

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <KakaoChannel /> {/* 카카오 채널 버튼 추가 */}
    </div>
  );
};

export default Layout;